import { createTheme } from '@ant-design/cssinjs';
import React from 'react';
import defaultDerivative from './themes/default';
import defaultSeedToken from './themes/seed';
export var defaultTheme = createTheme(defaultDerivative); // ================================ Context =================================
// To ensure snapshot stable. We disable hashed in test env.

export var defaultConfig = {
  token: defaultSeedToken,
  hashed: true
};
export var DesignTokenContext = /*#__PURE__*/React.createContext(defaultConfig);